/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件由 yapi-to-typescript 自动生成，请勿直接修改！！！ */

// @ts-ignore
// prettier-ignore
import { QueryStringArrayFormat, Method, RequestBodyType, ResponseBodyType, prepare } from 'yapi-to-typescript'
// @ts-ignore
// prettier-ignore
import type { RequestConfig, RequestFunctionRestArgs } from 'yapi-to-typescript'
// @ts-ignore
import request from '../../../request';

type UserRequestRestArgs = RequestFunctionRestArgs<typeof request>;

// Request: 目前 React Hooks 功能有用到
export type Request<
  TRequestData,
  TRequestConfig extends RequestConfig,
  TRequestResult
> = (TRequestConfig['requestDataOptional'] extends true
  ? (requestData?: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult
  : (requestData: TRequestData, ...args: RequestFunctionRestArgs<typeof request>) => TRequestResult) & {
  requestConfig: TRequestConfig;
};

const mockUrl_0_0_0_0 = 'http://10.50.16.213:40001/mock/295' as any;
const devUrl_0_0_0_0 = '' as any;
const prodUrl_0_0_0_0 = 'http://127.0.0.1' as any;
const dataKey_0_0_0_0 = 'retdata' as any;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/{id}`
 */
export interface FormTemplateIdGetRequest {
  /**
   * 模板id
   */
  id: string;
}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/{id}`
 */
export interface FormTemplateIdGetResponse {
  /**
   * 主键
   */
  id?: number;
  /**
   * 名称
   */
  name?: string;
  /**
   * 说明
   */
  description?: string;
  /**
   * 接口URL
   */
  url?: string;
  /**
   * 接口body
   */
  body?: string;
  /**
   * 状态。
   */
  status?: number;
  /**
   * 占位符
   */
  params?: string[];
  /**
   * 创建人staff id
   */
  createCropUserId?: string;
  /**
   * 创建人名称
   */
  createCropUserName?: string;
  /**
   * 更新人staff id
   */
  updateCropUserId?: string;
  /**
   * 更新人名称
   */
  updateCropUserName?: string;
  /**
   * 创建时间
   */
  createTime?: {
    /**
     * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
     */
    seconds?: number;
    /**
     * The number of nanoseconds, later along the time-line, from the seconds field.
     * This is always positive, and never exceeds 999,999,999.
     */
    nanos?: number;
  };
  /**
   * 更新时间
   */
  updateTime?: {
    /**
     * The number of seconds from the epoch of 1970-01-01T00:00:00Z.
     */
    seconds?: number;
    /**
     * The number of nanoseconds, later along the time-line, from the seconds field.
     * This is always positive, and never exceeds 999,999,999.
     */
    nanos?: number;
  };
}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/{id}`
 */
type ApiFormTemplateIdGetRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/formTemplate/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/{id}`
 */
const apiFormTemplateIdGetRequestConfig: ApiFormTemplateIdGetRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/formTemplate/{id}',
  method: Method.GET,
  requestHeaders: {},
  requestBodyType: RequestBodyType.query,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormTemplateIdGet',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `GET /api/formTemplate/{id}`
 */
export const apiFormTemplateIdGet = /*#__PURE__*/ (
  requestData: FormTemplateIdGetRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FormTemplateIdGetResponse>(prepare(apiFormTemplateIdGetRequestConfig, requestData), ...args);
};

apiFormTemplateIdGet.requestConfig = apiFormTemplateIdGetRequestConfig;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `PUT /api/formTemplate/{id}`
 */
export interface FormTemplateIdPutRequest {
  /**
   * 名称
   */
  name: string;
  /**
   * 说明
   */
  description?: string;
  /**
   * 接口URL
   */
  url: string;
  /**
   * 接口body
   */
  body: string;
  /**
   * 模板id
   */
  id: string;
}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `PUT /api/formTemplate/{id}`
 */
export interface FormTemplateIdPutResponse {}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `PUT /api/formTemplate/{id}`
 */
type ApiFormTemplateIdPutRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/formTemplate/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `PUT /api/formTemplate/{id}`
 */
const apiFormTemplateIdPutRequestConfig: ApiFormTemplateIdPutRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/formTemplate/{id}',
  method: Method.PUT,
  requestHeaders: {},
  requestBodyType: RequestBodyType.json,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormTemplateIdPut',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `PUT /api/formTemplate/{id}`
 */
export const apiFormTemplateIdPut = /*#__PURE__*/ (
  requestData: FormTemplateIdPutRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FormTemplateIdPutResponse>(prepare(apiFormTemplateIdPutRequestConfig, requestData), ...args);
};

apiFormTemplateIdPut.requestConfig = apiFormTemplateIdPutRequestConfig;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `DELETE /api/formTemplate/{id}`
 */
export interface FormTemplateIdDeleteRequest {
  /**
   * 模板id
   */
  id: string;
}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `DELETE /api/formTemplate/{id}`
 */
export interface FormTemplateIdDeleteResponse {}

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `DELETE /api/formTemplate/{id}`
 */
type ApiFormTemplateIdDeleteRequestConfig = Readonly<
  RequestConfig<
    'http://10.50.16.213:40001/mock/295',
    '',
    'http://127.0.0.1',
    '/api/formTemplate/{id}',
    'retdata',
    'id',
    string,
    false
  >
>;

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `DELETE /api/formTemplate/{id}`
 */
const apiFormTemplateIdDeleteRequestConfig: ApiFormTemplateIdDeleteRequestConfig = /*#__PURE__*/ {
  mockUrl: mockUrl_0_0_0_0,
  devUrl: devUrl_0_0_0_0,
  prodUrl: prodUrl_0_0_0_0,
  path: '/api/formTemplate/{id}',
  method: Method.DELETE,
  requestHeaders: {},
  requestBodyType: RequestBodyType.none,
  responseBodyType: ResponseBodyType.json,
  dataKey: dataKey_0_0_0_0,
  paramNames: ['id'],
  queryNames: [],
  requestDataOptional: false,
  requestDataJsonSchema: {},
  responseDataJsonSchema: {},
  requestFunctionName: 'apiFormTemplateIdDelete',
  queryStringArrayFormat: QueryStringArrayFormat.brackets,
  extraInfo: {},
};

/**
 * @分类 [mock表单模板管理↗](http://10.50.16.213:40001/project/295/interface/api/cat_2062)
 * @请求头 `DELETE /api/formTemplate/{id}`
 */
export const apiFormTemplateIdDelete = /*#__PURE__*/ (
  requestData: FormTemplateIdDeleteRequest,
  ...args: UserRequestRestArgs
) => {
  return request<FormTemplateIdDeleteResponse>(prepare(apiFormTemplateIdDeleteRequestConfig, requestData), ...args);
};

apiFormTemplateIdDelete.requestConfig = apiFormTemplateIdDeleteRequestConfig;

/* prettier-ignore-end */
